export const AppVersion = () => {
	return <div className="appVersion">{import.meta.env.VITE_APP_VERSION}</div>;
};
